export const usePrePayMonthsAllowed = () => {
    return { allowedPrePayMonths: _context.companySettings.allowedPrePayMonths, pendingPrePayMonths: false }
}